const actionStrings = (t, labels) => ({
  comment: t("document.actionStrings.comment"),
  document_import_uploaded: t("document.actionStrings.uploaded"),
  document_overridden: t("document.actionStrings.overridden"),
  document_approval_flow_auto_update: t(
    "document.actionStrings.approvalFlowAutoUpdate"
  ),
  document_import_deleted: t("document.actionStrings.deleted"),
  document_scheduled_for_activation: t(
    "document.actionStrings.scheduledForActivation"
  ),
  document_retired: t("document.actionStrings.retired"),
  document_import_cleaned: t("document.actionStrings.cleaned"),
  document_bulk_reviewed: t("document.actionStrings.bulkReviewed"),
  document_import_reimported: t("document.actionStrings.reImported"),
  document_import_sent_back_cleaning: t(
    "document.actionStrings.sentBackCleaned"
  ),
  document_import_internal_hold_removed: t(
    "document.actionStrings.holdRemoved"
  ),
  document_recurring_acknowledgment_triggered: t(
    "document.actionStrings.recurringAcknowledgmentTriggered"
  ),
  document_pended: t("document.actionStrings.edited"),
  document_import_undeleted: t("document.actionStrings.unDeleted"),
  document_recurring_acknowledgment_assigned: t(
    "document.actionStrings.recurringAcknowledgmentAssigned"
  ),
  document_approval_rejected: t("document.actionStrings.rejected"),
  document_activated: t("document.actionStrings.activated"),
  document_tags_changed: t("document.actionStrings.referencesChanged", {
    referencesLabelPlural: labels.referencesLabelPlural
  }),
  document_import_external_hold_added: t(
    "document.actionStrings.clarificationRequired"
  ),
  document_accepted: t("document.actionStrings.accepted"),
  document_recurring_acknowledgments_removed: t(
    "document.actionStrings.recurringAcknowledgmentRemoved"
  ),
  document_category_changed: t("document.actionStrings.categoryChanged"),
  document_tenant_approved: t("document.actionStrings.approved"),
  document_deleted: t("document.actionStrings.deleted"),
  document_made_active: t("document.actionStrings.activated"),
  document_imported: t("document.actionStrings.initiallyImported"),
  document_origination_date_changed: t(
    "document.actionStrings.originationDateChanged"
  ),
  document_import_sent_back_extracting: t(
    "document.actionStrings.sentBackExtracting"
  ),
  document_created: t("document.actionStrings.created"),
  document_import_converted_source_file_changed: t(
    "document.actionStrings.convertedSourceFileChanged"
  ),
  document_responsibilities_transferred: t(
    "document.actionStrings.responsibilitiesTransferred"
  ),
  document_import_internal_hold_added: t(
    "document.actionStrings.internalHoldAdded"
  ),
  document_import_sent_back: t("document.actionStrings.sentBack"),
  document_approved: t("document.actionStrings.approved"),
  document_import_clean_override: t("document.actionStrings.cleaningOverride"),
  document_bulk_approved: t("document.actionStrings.bulkApproved"),
  document_category_name_changed: t(
    "document.actionStrings.categoryNameChanged"
  ),
  document_import_extract_override: t(
    "document.actionStrings.extractionOverride"
  ),
  document_effective_date_scheduled: t(
    "document.actionStrings.effectiveDateScheduleChanged"
  ),
  document_import_external_hold_removed: t(
    "document.actionStrings.holdRemoved"
  ),
  document_import_extracted: t("document.actionStrings.extracted"),
  document_import_confirmed: t("document.actionStrings.confirmed"),
  document_pended_nochanges: t("document.actionStrings.noChanges"),
  document_draft_saved: t("document.actionStrings.draftSaved"),
  document_find_and_replace: t("document.actionStrings.findAndReplace"),
  document_draft_discarded: t("document.actionStrings.draftDiscarded")
});

export default actionStrings;
